import { useAuth } from '@polvo-labs/react-auth'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { setTimeout } from 'timers'
import Header from '.'
import routes from '../../config/routes'
import ChatModal from '../../modals/Chat'
import isAdmin from '../../utils/is-admin'
import isCommon from '../../utils/is-common'
import Button from '../Button'
import Icon from '../Icon'
import { InMenuContent } from './styles'

const CommonHeader = () => {
  const { user, authenticated } = useAuth()
  const history = useHistory()
  const [isCommonLocal, setIsCommonLocal] = useState(isCommon(user))
  useEffect(() => {
    setIsCommonLocal(isCommon(user))
  }, [user])

  const newRealtyButton = isCommonLocal && user && (
    <Button
      label="Cadastrar imóvel com dívida"
      onClick={() => {
        setTimeout(() => {
          history.push(routes.realty.create.path)
        }, 0)
      }}
    />)

  const chatModal = isCommonLocal && user && !isAdmin(user) && (
    <ChatModal
      roomUuid={user.chat_room !== null ? user.chat_room.uuid : null}
    />)

  return (
    <Header
      outerMenu={chatModal}
    >
      {authenticated && user && (
        <>
          {newRealtyButton}
          <InMenuContent>
            {chatModal}
          </InMenuContent>
        </>
      )}
      {!authenticated && (
        <>
          <Button
            label="Cadastrar imóvel com dívida"
            onClick={() => {
              if (authenticated) {
                history.push(routes.realty.create.path)
              } else {
                history.push(routes.login.path)
              }
            }}
          />
          <Button
            before={(
              <Icon
                name="account"
              />
            )}
            label="Acessar conta"
            backgroundColor="green"
            onClick={() => {
              setTimeout(() => {
                history.push(routes.login.path)
              }, 0)
            }}
          />
        </>
      )}
    </Header>
  )
}

export default CommonHeader
